import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { ItemStoreEvents } from "../itemStore.store";
import { i18n } from "@/i18n";
import { showConfirm } from "@core/ui/alert/alert";

export const sceneLayerStoreHooks: Partial<ItemStoreEvents<SceneNodeItem<"layer">>> = {
  async canBeDeleted(item, store, extraOptions) {
    if (item.data.layerType === "links") return false;
    if (extraOptions?.instant) return true; // Skip confirmation if deletion is instant (e.g. when deleting parent scene)
    
    // Get children from sceneNodes
    const children = Object.values(store.items).filter(
      node => node.parentSceneNodeUid === item.uid
    );
    
    if (children.length === 0) return true;
    
    return await showConfirm(
      i18n.t("questions.deleteSceneLayer"),
      i18n.t("actions.deleteSceneLayer"),
      i18n.t("labels.abort")
    );
  },

  async afterDelete(item, store) {
    // Delete all child scene nodes
    const children = Object.values(store.items).filter(
      node => node.parentSceneNodeUid === item.uid
    );
    
    for (const child of children) {
      await store.delete({ id: child.id, instant: true });
    }
  }
};
